import { inject } from '@angular/core'
import { Store } from '@ngrx/store'
import { isMobile } from '../state/layout/layout.selectors'

export abstract class AbstractComponent {
	protected store = inject(Store)
	protected isMobile = false

	constructor() {
		this.store.select(isMobile).subscribe(isMobile => (this.isMobile = isMobile))
	}
}
